<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 10:00:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:51:17
 * @name: 待审核人员
 * @Description: 待审核人员
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\wait-approve.vue
 * @Author: desktop
-->
<template>
  <div class="waitApprove">
    <table-normal>
      <template v-slot:title>
        <div class="title">
          <font>待审核人员</font>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="tableData"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="realname" label="姓名">
          </el-table-column>
          <el-table-column align="center" prop="mobile" label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="resolve(scope.row)"
                >通过</el-button
              >
              <el-button type="text" size="mini" @click="reject(scope.row)"
                >拒绝</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="total"
        ></Pagination>
      </template>
    </table-normal>
    <approve-resolve
      :mailList="mailList"
      ref="approveResolve"
      @approveResolveHandler="approveResolveHandler"
    ></approve-resolve>
  </div>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";
import approveResolve from "./dialog/approve-resolve.vue";
import { confirmation, debounceation } from "@/utils/decorator";
export default {
  name: "waitApprove",
  components: {
    tableNormal,
    approveResolve,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pagination: {
        page: 1,
        limit: 10,
      },
      loading: false,
    };
  },
  watch: {
    // 分页器信息变化,更新人员表格数据
    pagination: {
      handler(nv, ov) {
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取列表
     */
    getList() {
      this.loading = true;
      this.mailList
        .userGetVerifyList({ ...this.pagination })
        .then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    @debounceation(300)
    resolve(row) {
      this.$refs.approveResolve.open(row);
    },
    @debounceation(300)
    approveResolveHandler(obj) {
      this.submit({
        id: obj.id,
        act: "OK",
        department_id: obj.department_id,
        role_id: obj.role_id,
      });
    },
    @confirmation((row) => `是否拒绝${row.realname}发起的注册审批？`)
    reject(row) {
      this.submit({
        id: row.id,
        act: -1,
      });
    },
    submit(req) {
      this.mailList.userVerify(req).then((res) => {
        this.$message.success(req.act === "OK" ? "已成功" : "已拒绝");
        this.$refs.approveResolve.cancel(); //关闭弹窗
        this.getList();
        this.mailList.getTreeList(); //获取新的树结构
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.waitApprove {
  width: 100%;
}
</style>